import React, { Component } from 'react'
import { leader } from 'constants/wizards'
import { meta } from 'helpers/decorators'
import { Wizard } from 'components/masters'
import { WizardProgress } from 'components/layout'
import { renderRoutes } from 'react-router-config'

@meta({
  title: 'Register leader'
})
class Leader extends Component {
  render() {
    const { route } = this.props
    const children = route && renderRoutes(route.routes)

    return (
      <Wizard
        items={leader}
        wizardProgress={<WizardProgress {...this.props} />}
        {...this.props}
      >
        {children}
      </Wizard>
    )
  }
}

export default Leader
